import React from "react";
import Dynamics from './dynamics';
import HeaderDashboardLayout from "../../../../components/layouts/headerDashboardLayout/HeaderDashboardLayout";
import { withLayout } from "../../DashboardPage";
import { DetalizationWorkState } from "../../../../store/reducers/dashboard/works/detalization";
import { useTypedSelector } from "@hooks/useTypedSelector";
import Efficiency from "@pages/dashboard/works/detalization/efficiency";
import usePeriodParam from "@pages/dashboard/works/detalization/hooks/usePeriodParam";

const WorksDetailedPage = () => {
    const {
        data: {
            detailProgressByDays: { workName }
        },
        isApiLoading
    } = useTypedSelector<DetalizationWorkState>(state => state.workDetalization);

    const [period, setPeriod] = usePeriodParam('period');

    return (
        <HeaderDashboardLayout
            title={isApiLoading ? "" : workName }
            containerStyles={{gap: 20, paddingBottom: 20}}
            cropVisible={false}
        >
            <Efficiency period={period} setPeriod={setPeriod} />
            <Dynamics period={period} />
        </HeaderDashboardLayout>
    )
}
export default withLayout(WorksDetailedPage)
